import fastclick from "fastclick";
fastclick.attach(document.body);


// WEBPACK FOOTER //
// ./assets/js/plugins/fastclick.js